module.exports = __webpack_public_path__ + "img/heart-lock.29bb5b1d.png";